import { requestTokenAction } from "@/app/actions";
import { getCaptchaToken } from "@/services/google";
import { loadScript } from "@/utils/scripts";
import { useFormState } from "react-dom";
import Button from "../button";
import InputField from "../form/input-field";
import InfoHeader from "./info-header";

type LoginProps = {
  onSuccess: (email: string, createdUser?: boolean) => void;
  onError: (message: string) => void;
  isApp: boolean;
  redirectUrl?: string;
};
const Login = ({ onSuccess, onError, isApp, redirectUrl }: LoginProps) => {
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY;

  const [res, action]: any = useFormState(async (state: any, formData: any) => {
    const email = formData.get("email");
    let token = "";

    if (!email) return;

    if (siteKey) {
      await loadScript({
        src: `https://www.google.com/recaptcha/api.js?render=${siteKey}`,
        async: true,
        defer: true,
        waitFor: () =>
          new Promise<void>((resolve, reject) => {
            const test = (tries: number) => {
              if (typeof (window as any)?.grecaptcha?.execute !== "undefined") {
                resolve();
              } else if (tries > 40) {
                reject();
              } else {
                setTimeout(() => test(tries + 1), tries < 10 ? 100 : 350);
              }
            };

            test(0);
          }),
      });

      token = await getCaptchaToken("submit_login", siteKey);
    }
    else {
      token = "captcha-disabled";
    }

    const res = await requestTokenAction(
      formData.get("email"),
      token,
      isApp,
      redirectUrl
    );

    if (res == false || res?.success === false) {
      return onError("Kunde inte skicka e-post");
    }
    if (res.createUser == true) {
      return onSuccess(email, true);
    }
    onSuccess(email);
  }, null);

  return (
    <>
      <InfoHeader header="Logga in" description="Ange e-postadress nedanför." />
      <form className="mb-10" action={action}>
        <div className="w-full relative h-16">
          <InputField
            label="E-postadress"
            type="email"
            placeholder="Ange e-postadress"
            containerClassName="h-16 absolute w-full"
            className="h-full rounded-sm pr-[60px]"
            name="email"
            required
            autoComplete="email"
          />
          <Button
            showLoader={true}
            type="submit"
            className="btn btn-primary h-12 flex items-center absolute right-2 top-2 z-10 font-bold"
          >
            Fortsätt
          </Button>
        </div>
      </form>
      <p className="mb-8">
        <span className="font-bold">Saknar du konto?</span> Ange din
        e-postadress ovanför och påbörja registreringen.
      </p>
      <div className="bg-sand-600 p-4 prose rounded-sm max-w-none text-black-400">
        <h4 className="font-semibold font-noto-sans text-black-400 mb-0">
          Information
        </h4>
        <p>
          På efn.se behöver du inte hålla reda på några lösenord. Ange bara din
          e-postadress ovanför, så skickar vi en länk för att logga in direkt.
        </p>
      </div>
    </>
  );
};

export default Login;
